// Image lightbox, gallery wiring, and live stock refresh.
// Moved out of hol-main.liquid. Loads after hol-theme.js.

var _lbGallery = [];
var _lbIdx = 0;

function _lbRender() {
  var img = document.getElementById('lightbox-img');
  var counter = document.getElementById('lb-counter');
  var prev = document.getElementById('lb-prev');
  var next = document.getElementById('lb-next');
  if(img) img.src = _lbGallery[_lbIdx];
  if(counter) counter.textContent = _lbGallery.length > 1 ? (_lbIdx+1)+' / '+_lbGallery.length : '';
  if(prev) prev.style.visibility = _lbGallery.length > 1 ? 'visible' : 'hidden';
  if(next) next.style.visibility = _lbGallery.length > 1 ? 'visible' : 'hidden';
  if(img) img.style.objectFit = 'contain';
}

function openLightbox(src, gallery, idx) {
  _lbGallery = gallery && gallery.length ? gallery : [src];
  _lbIdx = (idx !== undefined && idx >= 0) ? idx : Math.max(_lbGallery.indexOf(src), 0);
  _lbRender();
  document.getElementById('lightbox').style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function lbNav(dir) {
  _lbIdx = (_lbIdx + dir + _lbGallery.length) % _lbGallery.length;
  _lbRender();
}

function closeLightbox() {
  document.getElementById('lightbox').style.display = 'none';
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', function() {
  var lbEl = document.getElementById('lightbox');
  var lbClose = document.getElementById('lb-close');
  var lbPrev = document.getElementById('lb-prev');
  var lbNext = document.getElementById('lb-next');
  if(lbEl) lbEl.addEventListener('click', function(e){ if(e.target===lbEl) closeLightbox(); });
  if(lbClose) lbClose.addEventListener('click', function(e){ e.stopPropagation(); closeLightbox(); });
  if(lbPrev) lbPrev.addEventListener('click', function(e){ e.stopPropagation(); lbNav(-1); });
  if(lbNext) lbNext.addEventListener('click', function(e){ e.stopPropagation(); lbNav(1); });

  document.addEventListener('keydown', function(e) {
    var lb = document.getElementById('lightbox');
    if(!lb || lb.style.display === 'none') return;
    if(e.key === 'ArrowLeft')  lbNav(-1);
    if(e.key === 'ArrowRight') lbNav(1);
    if(e.key === 'Escape')     closeLightbox();
  });

  // Which set of photos the lightbox pages through. A card with variants keeps
  // one .vpanel per variant and shows only the live one, so the id of whichever
  // panel is on screen names the variant: #apron-black -> 'black'. This used to
  // assume every variant was called scented or unscented, which was true until
  // the apron arrived in black and ivory.
  function getProductGallery(prefix) {
    if(!window.PRODUCT_IMAGES) return {gallery:[]};
    var pi = PRODUCT_IMAGES[prefix];
    if(!pi) return {gallery:[]};
    if(Array.isArray(pi)) return {gallery: pi};
    var panels = document.querySelectorAll('.vpanel[id^="'+prefix+'-"]');
    for(var i=0; i<panels.length; i++){
      if(panels[i].style.display !== 'none'){
        var name = panels[i].id.slice(prefix.length + 1);
        if(typeof pi[name] !== 'undefined') return {gallery: pi[name]};
      }
    }
    var first = Object.keys(pi)[0];
    return {gallery: first ? pi[first] : []};
  }

  function applyFit(img){
    var isDim = img.src && (img.src.indexOf('Dimension') > -1 || img.src.indexOf('dimension') > -1);
    img.classList.toggle('dim-img', isDim);
  }

  document.querySelectorAll('[id$="-main-img"]').forEach(function(img) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('load', function(){ applyFit(this); });
    applyFit(img);
    img.addEventListener('click', function() {
      var prefix = this.id.replace('-main-img', '');
      var info = getProductGallery(prefix);
      var gallery = info.gallery.length ? info.gallery : [this.src];
      var idx = gallery.indexOf(this.src);
      if(idx < 0) idx = 0;
      openLightbox(this.src, gallery, idx);
    });
  });

  document.querySelectorAll('.col-images img').forEach(function(img, i) {
    img.onclick = null;
    img.addEventListener('click', function() {
      var gallery = Array.isArray(PRODUCT_IMAGES.collection) ? PRODUCT_IMAGES.collection : [this.src];
      openLightbox(this.src, gallery, i);
    });
  });

  if(window.swapImg){
    var _orig = window.swapImg;
    window.swapImg = function(mainId, thumb, stripId){
      _orig(mainId, thumb, stripId);
      setTimeout(function(){ var m = document.getElementById(mainId); if(m) applyFit(m); }, 30);
    };
  }

  // Correct the rendered stock counts against live Shopify data, then
  // re-cap the quantity steppers so nobody can order more than exists.
  var MAP = {
    'heart-of-life-wood-diffuser-block':   ['hol-scented','hol-unscented'],
    'tree-of-life-wood-diffuser-block':    ['tol-scented','tol-unscented'],
    'key-of-life-wood-diffuser-block':     ['kol-scented','kol-unscented'],
    'flower-of-life-wood-diffuser-block':  ['fol-scented','fol-unscented'],
    'the-four-pathways-collection-scented-wood-diffuser-set': ['collection'],
    'the-flower-of-life-reading-companion': ['folbm'],
    'flower-of-life-ritual-apron':          ['apron-black','apron-ivory']
  };
  Object.keys(MAP).forEach(function(handle) {
    fetch('/products/'+handle+'.js')
      .then(function(r){ return r.json(); })
      .then(function(p){
        p.variants.forEach(function(v, i){
          var key = MAP[handle][i];
          if(!key) return;
          // The storefront's products.js does not expose inventory_quantity, so
          // this refresh can only ever confirm "sold out". It used to flatten an
          // accurate Liquid-rendered count to 99 for every product listed in MAP,
          // which silenced the exact-count stock rule. Now a sold-out item is
          // corrected and anything else keeps the count the page rendered.
          var qty = (v.inventory_quantity != null) ? v.inventory_quantity : null;
          if(!v.available) qty = 0;
          if(qty === null) return;
          STOCK[key] = qty;
          if(window.renderStock) window.renderStock(key);
          var input = document.getElementById('qty-'+key);
          if(input){
            input.max = qty > 0 ? qty : 1;
            if(parseInt(input.value,10) > qty) input.value = qty > 0 ? qty : 1;
          }
        });
      }).catch(function(){});
  });
});
